import { AxiosResponse } from "axios";
import { getMimeType } from "helpers/get-mime-type";

export const PreviewFile = (fileResponse: AxiosResponse, action: "preview" | "download") => {
  const contentDisposition: string = fileResponse.headers["content-disposition"];
  let filename = "";
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = match[1];
    }
  }
  const mime = getMimeType(filename);
  const blobFile = new File([fileResponse.data], filename, { type: mime });
  const fileURL = URL.createObjectURL(blobFile);

  switch (action) {
    case "preview":
      window.open(fileURL, "_blank");
      break;

    case "download":
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(fileURL);
      break;

    default:
      break;
  }
};
